
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clar`,
'deleteKey': `⌦ Ștergeți`,
'downKey': `↓ Jos`,
'endKey': `⤓ Sfârșit`,
'enterKey': `Introduceți`,
'escapeKey': `⎋ Evadare`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generați o 
          <code>LICENȚĂ 
          </code> fișier 
        `,
'homeKey': `⤒ Acasă`,
'keyCommand': `⌘ Comandă/Win`,
'keyControl': `^ Control`,
'keyOption': `⌥ Opțiune/Alt`,
'keyShift': `⇧ Schimb`,
'leftKey': `← Stânga`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Dreapta`,
's00065e45db8c0441': `Consultați instrumente pentru dezvoltatori pentru mai multe detalii`,
's001dd78415a91fa0': `Șanțul barei de defilare`,
's002fa7d1054ed082': `Caseta de frontieră`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `kazahă`,
's01b56d233c6c5cac': `Secționare`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Pin nou...`,
's02ab1ea8e5100fc1': `Marcați selecția ca o "suprapunere bidirecțională`,
's0312976fe9da5951': `Buton`,
's03608a32f05eded2': `Pinch zoom`,
's036d35e03be98d22': `Adâncime matematică`,
's037b1dc850a89273': `Alternativ sub`,
's0396202b716732ec': `Marcați selecția ca marcată prin`,
's03f49e598ffb11cc': `poloneză`,
's0448f1059fa01720': `Salvați, partajați sau imprimați explorabilul dvs. Modificați informații precum titlul, limba sau licența.`,
's0458872c43beadef': `Introduceți rândul înainte de`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Spațierea cuvintelor`,
's05e9759cfd99c48f': `Justificați`,
's063fa5a0a4903bf4': `În lateral, de la stânga la dreapta`,
's064339c229374050': `Codificare`,
's06634274f19b0572': `Selectarea pinilor`,
's06743b24499f0035': `Centru de ancorare`,
's07808b0ca6da8fef': `Site web împrejmuit`,
's07970793b21351fd': `Container de bază Ruby`,
's079cf7850d9327f0': `Font`,
's07aa10850d9ddcc7': `Forma`,
's07e6118e838b2e23': `Navigație`,
's0816468df86e4036': `Deschide setările`,
's082869038c117fe5': `Portugheză (Brazilia)`,
's086e6c267ade2609': `Saturație`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Introduceți o listă (fără ordine)`,
's09c3f1d21de14ae1': `Marcați selecția ca fiind subliniată`,
's0a2d91c6720033e9': `Spațiere text trim`,
's0a3ddcba94027d95': `Potrivirea obiectului`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Introduceți o navigație`,
's0a7db790db1fc45c': `Marcați selecția ca un interval`,
's0b1271f50a77dc73': `Cutie de conținut`,
's0b24d08ea349b455': `Tot ceea ce puteți insera. La început sunt elementele non-interactive precum listele sau imaginile, apoi sunt elementele interactive numite widget-uri. Puteți obține elemente noi făcând clic pe bara de căutare.`,
's0bdca49248ba4820': `Scurtături`,
's0befccf152b6c0a9': `Orient din metadate`,
's0c11e479416c8421': `Introduceți un titlu de tabel`,
's0c27336067c59611': `Căptușeală de derulare`,
's0c4593d81f147042': `Linia de bază`,
's0c4b2e98d4ab7f5a': `Comenzile aplicației`,
's0c883713b83616a8': `Salvați documentul activ`,
's0ca5c0460199cba1': `Abreviere`,
's0cf10c4f40588f8d': `Captură de tabel`,
's0d86afa3c6a1e28b': `Direcție flexibilă`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Documentul dvs. explorabil. Aici puteți scrie text și puteți face copy/paste, edita, etc.`,
's0dc452999c129e15': `Activarea reîncărcării live`,
's0de0febab8a4beaf': `Eroare la citirea acestui pachet`,
's0e44968489e076a8': `Chineză`,
's0e4862e87c7d53ce': `Marcați selecția ca citat`,
's0e6ea8870dbddab2': `Comenzi document`,
's0ee28503778e4c0c': `Ultima linie de bază`,
's0ef01c03299bbb83': `Decorațiuni`,
's0f17f32919661cff': `Mongolă`,
's0f350bc4e538e3ea': `Cuvinte`,
's105a06836c40fcb4': `Setați filtrele, culoarea și îmbinarea elementelor selectate`,
's106b274b5af798e5': `Propoziții`,
's1082e1649793dca9': `Marcați selecția ca un termen definit`,
's10f3845975a0351e': `Editarea metadatelor`,
's1125d159f7e64df5': `Afișaj`,
's11326fd2590f4e5e': `Implicit`,
's1155ec07a221e739': `Bara de derulare`,
's1173bf7a3e0b74c9': `Minim (y)`,
's1177237a3e0e548c': `Minim (x)`,
's1219d97b49650c05': `Vizibilitate`,
's123bea44f38abccf': `Introduceți un obiect`,
's1245e2cb9f20197e': `Aliniați`,
's12946ec1b850962c': `Introduceți coloana după`,
's1351209ef74ee729': `Întindeți toate coloanele`,
's13c60cb409e8cb6f': `Aliniați centrul`,
's13ebd619c8a06a6d': `Rânduri automate în grilă`,
's13ef8ca26ca8861b': `Element de tăiere`,
's151bc2eea7a032a4': `-schimbat-`,
's153bc3c3aa39587b': `Cap de masă`,
's156647179b21d351': `Introduceți un corp de tabel`,
's158b6ec6b1fffcb2': `Pauză după`,
's15d0c0657c1ee08c': `Cheie API`,
's1626a7e10a9f9dcc': `Setează familia de fonturi a selecției`,
's1637c7d1a30629e2': `Caseta de frontieră`,
's1641ab440bf4daa4': `Actualizați acest pachet de widget-uri`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avansat: Afișați pachetele cu versiuni precum 0.x.x în managerul de pachete`,
's16b9446e3a70e1f4': `Atribute`,
's16f205466761e583': `Nu există dimensionare optică a fonturilor`,
's16f2f1c2c516d307': `Deschideți un document`,
's1749014f3f87fa6a': `Întindere`,
's17597a8bb4810524': `Licență`,
's17bfaaa4e7528bc7': `Bașchir`,
's17fb3f4805f4f4b9': `Eliminarea câmpului`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Creați pachetul`,
's18d5c44aae3dc82a': `Online la editare`,
's1988d71ef8060edf': `Introduceți un rând de tabel`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Schiță`,
's1a1acc902e6668e0': `Afișați formatarea avansată a textului`,
's1a5230a71d9285c1': `Captură`,
's1aa1cb63ad44bc6f': `Decalaj între coloane`,
's1af8b67d1c85c811': `Spațiu între`,
's1b4a36fce2456660': `Familie de fonturi`,
's1c246045629b0016': `Marcați selecția ca fiind o ștergere`,
's1c3fc313a9184670': `Legătură publică`,
's1c65f5004a07dcfa': `Gaelică scoțiană`,
's1c690963f1e2df00': `Aspectul specific platformei`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Doriți un tur scurt, cu ghid?`,
's1d19244f549ec535': `Educație`,
's1d5c7b28e8b50d6d': `Grad asociat.`,
's1db591f5a54dbfd3': `Cutie de conținut`,
's1dbb9f50e16c92a3': `Raza de frontieră`,
's1dfb744260fb3a01': `Izolare bidirecțională`,
's1e9c2c654732cc5f': `bielorusă`,
's1eaccbf2d6af8ab5': `Informații`,
's1efbfc3937d565bd': `Context`,
's1f2b49c1bca2035d': `catalană`,
's1f74bdf32b51a5fc': `Imagine de fundal`,
's1f7698c061c208c9': `Deschis`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Corsican`,
's21d61916eb8d137d': `Corp de masă`,
's21d723a1dbcd89c8': `javaneză`,
's21f8a2eaf5a70749': `Introduceți o etichetă`,
's2206c42e5b835e6e': `Marcați selecția ca abreviere`,
's22a2348c46a912a0': `Introduceți o secțiune`,
's233ae776268cd44b': `Afaceri`,
's236ed7ba747099b0': `Greutatea fontului`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Text`,
's24949d7adbb5a098': `Cutie de instrumente`,
's252a52330d32b900': `Metadate`,
's2540844a4bc4d9ba': `Cereți atribuirea?`,
's255857544a9d5ec0': `Resetare`,
's255c77900f2b5e0f': `Schema de culori`,
's256ab831a48c941c': `Îndepărtează toate formatele textului din selecție`,
's2591806d7b222591': `Resetați modificările`,
's25e1a07e454c2c11': `Rețea`,
's262abbaf1d05f009': `Lumină moale`,
's266935f2447fcd98': `Peste stânga`,
's268ecd1cef45a9a8': `Sunteți sigur?`,
's2692bc028fed91f1': `⇪ Blocare majuscule`,
's27056379e0acfdb0': `Lighten`,
's27076e66c5d483ba': `Aliniere verticală`,
's2712dc5641a33226': `Conturile de registru pentru pachete sunt destinate dezvoltatorilor și vă permit să
          configurați unul sau mai multe registre`,
's27cc88818cc46ff6': `Stabilă`,
's281d957112b10f12': `Editați direct HTML-ul documentului`,
's28b6246ce616a548': `Introduceți un grup de coloane de tabel`,
's29a1c26521879b9f': `Reducerea scalei`,
's29acfd2778e8c377': `Ascundeți formatarea avansată a textului`,
's29b24c06315e9343': `Introduceți o intrare`,
's29eb103449472e3b': `Introduceți un titlu (nivelul 3)`,
's29ee7434494a0dfe': `Introduceți un titlu (nivelul 2)`,
's29f21c34494d614d': `Introduceți un titlu (nivelul 1)`,
's29fbfc3449557f72': `Introduceți un titlu (nivelul 6)`,
's29ff743449588131': `Introduceți un titlu (nivelul 5)`,
's2a031834495bcdb4': `Introduceți un titlu (nivelul 4)`,
's2a75c946ef4dcab7': `Diverse`,
's2b2ae20d26f78ac2': `Bloc`,
's2b8f50c64be440f7': str`Selectați 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Comandă`,
's2bad2d24def4aa0b': `Întrerupere linie (CJK lang.)`,
's2ceb11be2290bb1b': `Anulează`,
's2ced8e8fafb499f6': `Ștergeți elementul`,
's2d986d31f8d67357': `Introduceți un set de câmpuri`,
's2d995a37cf5e4995': `Introduceți un NoScript`,
's2de969afacdaa7a6': `Formă`,
's2df075aface0dab8': `Share`,
's2e192b19ed15fcf6': `Pagina`,
's2e39b99cf23606fa': `Setează aspectul elementelor selectate`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Depășire (y)`,
's2edd6688a65e21f0': `Depășire (x)`,
's2f0bcdffc92a786b': `Flotor dreapta`,
's2f2044f2431a32d5': `Titlul`,
's2f4d4bfbc466d91f': `albaneză`,
's2f8da2cb5f236588': `Numele pachetului dumneavoastră. Trebuie să fie delimitat, de exemplu \`@org/pkg\`. `,
's30cce87854901922': `Preșcolar`,
's3124653c272f054c': `Culoarea regulii coloanei`,
's314a4f7685c8e824': `Întotdeauna`,
's31c06e226322f065': `Evitați orfanii`,
's323dcde72b850272': `Acces public`,
's32911e52ee8ac745': `Introduceți un slot`,
's337a1e9022a8d19f': `Tabel`,
's33c1450d2822bb0f': `Introduceți o legendă a figurii`,
's33c18d5a4cbffa2a': `Irlandeză`,
's33f85f24c0f5f008': `Salvați`,
's342b0cabfa672822': `Ajutați utilizatorul să vă găsească widget-ul`,
's3437e0d9899e7ae1': `Trimiteți date telemetrice despre utilizarea de către dvs. a WebWriter.`,
's344ea8f4939cdc98': `Culoare`,
's34dcda3b0f9d5a98': `Schimbare url`,
's34f724979a124c50': `Setează culoarea de fundal a textului selectat`,
's355b21b89ce5d9c5': `Detalii`,
's35ae5f4e0fa2777b': `Aliniere personalizată`,
's35aeaff1425bca9e': `WebWriter nu acceptă media de tip `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Cod`,
's3649bacefe731bf6': `Toggle Toolbox`,
's365280e16a8ea32d': `Copiați selecția`,
's366991b9c9287765': `Corect`,
's36a194e38d653a26': `Adnotarea datelor`,
's36b3cefdcb897f15': `Perspectivă`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Listă ordonată`,
's37a8c35f6581da5f': `Fără ancoră`,
's37fa3b9cd51c2dfd': `Setează dimensiunea fontului selecției`,
's380d17664bb69531': `Introduceți coloana înainte de`,
's3815184eb09f0dcf': `Cursor`,
's382a2aa3984474dd': `Creați`,
's38980f98cb07ceb8': `Salvați documentul activ ca o copie`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Poziția Ruby`,
's3a5ca02f282d247e': `Share...`,
's3ae67088bbefba98': `Pachete`,
's3b0ab4b52326316f': `Lumină`,
's3bdad99768e11911': `Explorabil`,
's3cb47df8290fa94c': `Introduceți o opțiune`,
's3cf89cb47fdde7e9': `Legătură`,
's3d09398e555ee5f9': `Opțiuni avansate`,
's3d249bb480032121': `Listă`,
's3d3efd1e19bdcfb4': `Adnotare dată/oră`,
's3d6a732c792ccb9e': `Adnotare Ruby`,
's3d93f9ea0c5a13fa': `Imagine`,
's3d9548e211b958ce': `Săriți peste suprapuneri`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Drăguț`,
's3eb6d1e6e79ed7c4': `Nu s-au găsit documente`,
's3eca5a034978754b': `Ștergeți selecția`,
's3f06e9abb6ebcb79': `Personaje`,
's3f1e7a3f2b283d3b': `Marjă`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Introduceți un articol`,
's3fd83566dd643d10': `Introduceți o legendă`,
's3fe72792941c18f9': `Textul de jos`,
's3ffcdc5db5e7d0c5': `Inversare`,
's40e3826b7f74a3b5': `Pan (dreapta)`,
's40f07d7859284a44': `Linia de bază dominantă`,
's4101ada154a1b958': `Mijlociu`,
's410c465a5993f82d': `Oportunitate de întrerupere a liniei`,
's41322d19c928c603': `TIC`,
's417b90913e05bc17': `Previzualizare`,
's418f2020fe996832': `Confirmați modificările`,
's41c724f0698148e9': `Marcați selecția ca o comandă rapidă de la tastatură`,
's41f65a763f8e44ab': `Grup de antet de tabel`,
's42721130228841b0': `Cutie de curse`,
's429bd646f1cf8bc6': `Conturile Grammar LLM vă permit să utilizați API-ul Grammar LLM pentru a corecta gramatica în text.`,
's429dd933ba95549b': `Introduceți o adresă`,
's42e470ef1d707a28': `Joc automat`,
's42ffdab1291fb3de': `Introduceți rândul după`,
's430831017f3f0499': `Oscilație (y)`,
's430bd5017f42511c': `Înclinare (x)`,
's433ba70286202ceb': `Rupeți toate`,
's441b20a8a50e36b4': `macedoneană`,
's445b8acb9206db6e': `Aruncați și anulați`,
's446a924922651ea0': `Accentuarea textului`,
's44cdba92713de38e': `Zona de rețea`,
's45518abd911471d0': `croată`,
's456a8d744313852a': `Spațiu în jurul`,
's4634541f5056a546': `Abhaziană`,
's46d4abe6255cb9e1': `Reatribuire comandă rapidă`,
's4730c232e7209c40': `Tăiați ambele`,
's474f0eec369d02a4': `Exemplu de ieșire`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Marcați selecția ca o adnotare dată/timp`,
's47ebf3a8fb3b10c1': `Orientare`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opțiune`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Umbra textului`,
's4993444bfd3f3e5e': `Colaps`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Mască`,
's49dd67aed00029ef': `Matematică`,
's49e763aed00877a8': `Principală`,
's4a894f57eba1cf1e': `Comandă rapidă de la tastatură`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Lumină puternică`,
's4b2c143acf931122': `Înălțimea liniei`,
's4b58c01e2578f5e4': `Legendă`,
's4bbff4e008690da1': `Evitați pagina`,
's4c402ff5355fd310': `Suprascriere bidirecțională`,
's4caed5b7a7e5d89b': `Engleză`,
's4cb38675a21b2c98': `Tip de proprietate nesuportat "\${desc.type}" (procesare ca JSON)`,
's4cc8391f172c0cdf': `Anulați turul`,
's4d528b416ac8dee2': `Introduceți un grup de titluri`,
's4d546f6c87128d5b': `Primul spațiu`,
's4dcb9315f6527f9c': `Rulați la reîncărcare`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Eroare de conectare`,
's4e361bf8eef3759a': `Ruptură de cuvânt`,
's4ea0f21fc2a338a1': `Înaintează`,
's4eace13b3ed74187': `Comentariu lateral`,
's4efee5b48a4593cb': `Bucla`,
's4f26e7cb7c0a8318': `Desen vectorial`,
's4fd2e638aabb0bb3': `WebWriter acceptă încorporarea mai multor surse diferite. Pur și simplu lipiți un
          link către conținut din:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thailandeză`,
's5015a8fb33b98872': `Subțire`,
's50489ffb1bde152e': `Inserție`,
's5068560b8d39663d': `Hartă pe care se poate face clic`,
's517acbf1f96324f9': `Greutate`,
's523eb9043213ff0d': `italic`,
's52777d434baeed9b': `Introduceți un indicator de progres`,
's52af5d7ac34c2163': `Rând de masă`,
's52e0bdc3ee304436': `Introduceți un contor`,
's531056f039febd39': `Introduceți o selecție`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Deschideți sau închideți caseta de instrumente (numai pe ecrane înguste, în caz contrar, caseta de instrumente este întotdeauna vizibilă pe lateral).`,
's5432ad3c84273229': `Figura`,
's543906d1db8b2283': `Editare `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `cambodgian`,
's54897f2764b0e4d0': `Instalați acest pachet widget`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Marcați selecția ca fiind foarte importantă`,
's55905c735052d295': `Pauză tematică`,
's5590dbf7e425789d': `Etichetă`,
's5623aa2f83b05c76': `Tibetană`,
's564d1648b1ceee9f': `La zi`,
's565cd5ffb0158c46': `Evitați regiunea`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Înapoi`,
's5787c6d5b3b5541a': `Calea clipului`,
's579c69f419b6caef': `Netedă`,
's587ac858dd80f6fa': `Subscripție`,
's58bec0ecd4f3ccd4': `Strict`,
's59404f5593c32fdc': `Font kerning`,
's5941292bb77281ab': `Norvegiană Bokmål`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Marcați selecția cu o adnotare de date`,
's5a356677b61a6b7e': `moldovenească`,
's5b474b5c0ac0c7c4': `Grup de coloane de tabel`,
's5b517ac216f9ee62': `În lateral`,
's5b8cc9bb61ddce15': `Introduceți un paragraf`,
's5bba2ac2e53bd1fd': `Kirghiz`,
's5be80ad6b8301710': `Start în linie`,
's5c1ecf88259b79f9': `Prezentare`,
's5c2a1a52c0389c30': `Inginerie`,
's5c63af7695445fcf': `Stilul textului`,
's5d18ca4c3111be6f': `Introduceți un cap de tabel`,
's5d87c1e588f48d90': `Practică`,
's5d929ff1619ac0c9': `Căutare`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Conectați-vă`,
's5e2cba97c0d971bd': `Pachete de reîncărcare`,
's5e53415a6d5719ad': `Științe sociale`,
's5e6a7a0c30d2a270': `Sari peste suprapuneri (auto)`,
's5e9e8e4d21bafedc': `Producția alimentară`,
's5ed03bb1f3a15949': `Imagine`,
's5f43af3669b1e098': `Sursa`,
's5feaf7fd7ee567c8': `Cuvânt de pauză`,
's600fd23c9ce971e8': `Tipăriți documentul activ`,
's602bbd28dae2c60f': `Start automat`,
's60ff598dfcf2c773': `Sub dreapta`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tabel Coloană`,
's6196153c4b0c1ea0': `Instalați`,
's61c017f6d5c303af': `Frisonă`,
's61ded17ca3f48c82': `Compensarea sublinierii`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Selectare copie`,
's624e31cd4f1b89d4': `Derulare lină`,
's626daf42b1ab7df7': `Alinierea la stânga`,
's6280bf993915c57a': `Marja de derulare`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Descriere`,
's63dfc5b1c1c27849': `Yiddish`,
's63e03c70f67ebf9c': `Context`,
's63e71d20d1eaca93': `germană`,
's640bc7710d0143ce': `Refacerea ultimei modificări anulate în documentul activ`,
's64dc1fc7e3db45c9': `Creați un document nou`,
's65ac276544ba33cd': `fișier SVG`,
's66765c420ee578e4': `Spațiu uniform`,
's669b18c6d2d9c95b': `Niciuna`,
's6747dbf4ad6063ba': `Sfârșit propriu`,
's6787497df07fa97e': `Poate derula peste opriri`,
's67c2b60a506a09e4': `Ed. secundară.`,
's680bd4d926cd5a84': `Păstrați 3D`,
's6827930ef1aeaf99': `URL de bază`,
's684a16f3c711394d': `Peste dreapta`,
's687e27f036a71b32': `Izolați`,
's68b87d7b61052dc3': `Rând de masă`,
's68e0e3a2bab7ce3e': `Evitați`,
's690da6b432987c6f': `Copiază automat modificările din documentul curent. Modificările sunt restaurate atunci când WebWriter este reîncărcat.`,
's69311c4e25074fb3': `Școala secundară`,
's697400b541fbc3cd': `Sub`,
's6988ab5d47593a26': `Aveți cea mai recentă versiune a WebWriter.`,
's69a49786a8009f43': `Găsiți pachete...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Acoperire`,
's69fbbdb8ad2a084a': `Întunecare`,
's6a31eff1ec4f71ad': `Ascunde fața din spate (3D)`,
's6ac62e1c8c66f3bb': `Compact superscr.`,
's6b585ba37cdb8260': `Moștenire`,
's6b61f8abf89586be': `ebraică`,
's6bd7a02fdf93e653': `Aliniați conținutul`,
's6cfc66b824ea05ba': `Margini clare`,
's6d02dc19e21eb49c': `Sus`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `vietnameză`,
's6d8b3b8047ed378d': `Mod de amestecare`,
's6d8c02aee480af7a': `Meniu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Introduceți un stil`,
's6e288a119281f4c2': `Redarea textului`,
's6e4c20c6debcd5ca': `Justificare personalizată`,
's6f84199e62584905': `Text preformatat`,
's6fb3053e7244d326': `Alte domenii`,
's70178e04a3b691b6': `Deschideți setările`,
's7031ca562378bde6': `Precizie geometrică`,
's7060970b5ed20a58': `Interactivitate`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Afișați pachetele instabile`,
's71dec51005acc1e4': `Rând dens`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Obiect`,
's731678e227a20559': `Acest dispozitiv`,
's736904f276fbd441': `Științe naturale`,
's739544d0c858c633': str`Sau lăsați 
          ${0} aici 
        `,
's73cb20c838e761e1': `Selectarea tăieturii`,
's7417792bbe720149': `Refacere`,
's741fae02b3dd24f3': `Pixelate`,
's743f778233e42a3f': `Introduceți o paranteză`,
's744d993d03f29851': `Ecran`,
's748c0074eff45884': `Manipulare`,
's74aa0039a87141e2': `Elipsă`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Caseta de umplere`,
's75109f5307578a61': `Bine ați venit la WebWriter`,
's75a27f43413e02c5': `franceză`,
's75d83fc3f0cfab40': `Antet`,
's762e5704cc84089d': `Setarea altor opțiuni de stil ale elementelor selectate`,
's77318393dfdb0775': `Îndepărtați rândul`,
's77e594ddcc10c774': `Permiteți utilizarea comercială?`,
's782eac2b3e80323d': `Marcați selecția ca fiind accentuată`,
's782f286a79cca35d': `Relativ`,
's78673a3539cb1915': `Sus stânga`,
's78789724e789221c': `Mărime`,
's789ff24c8f03f1a4': `Spațierea literelor`,
's7995733bf97c01cc': `sârbo-croată`,
's7a99528e7b64635a': `Occitană`,
's7aaf0c06e69600f1': `Eroare cu `,
's7ae49e142487766c': `Acces comunitar`,
's7af555180b30a947': `Deschideți instrumentele dezvoltatorului`,
's7b4ba250601b8667': `Introduceți un șablon`,
's7b560d8693ed8f42': `În poziție verticală`,
's7b9994904c4f5b54': `Tadjik`,
's7bdf0fd5b014d36c': `Importanță puternică`,
's7beb1e77e82363eb': `Anularea ultimei modificări în documentul activ`,
's7c61118554a0ec36': `Maxim (x)`,
's7c95876637f6a9d7': `Filtru`,
's7cb4e55c59663b1c': `Compania`,
's7cfe12cd14df9950': `Deconectare`,
's7d27db3c9639c6dd': `Alternativă`,
's7d8103f6f06f83d6': `Căptușeală`,
's7d864465dddbb50d': `Permite redimensionarea`,
's7de0e28d6c309a4e': `Permiteți acțiuni tactile`,
's7dea785045c3cc74': `Apăsați noua combinație de taste...`,
's7e0b179d4d1414eb': `Introduceți link-ul`,
's7e6570f2f1ae320f': `Sintetizarea caracterelor tipografice`,
's7ecb1f29332293e5': `Linia de bază a alinierii`,
's7ed13ccddb1bf3c3': `Suprapunere`,
's7edbe0b213199995': `Diplomă de licență`,
's7ede1c55e35ce9d6': `Simulare`,
's7f09197a4814079b': `Setarea opțiunilor de interactivitate pentru elementele selectate`,
's7f326a142e856656': `Stil`,
's7fcb35d23be1e643': `Set de câmpuri`,
's80570196a9ce6d11': `Activați telemetria`,
's806f84eb0ace116e': `Vedeți ce ați selectat și modificați. Copiați, tăiați, lipiți, fixați sau efectuați modificări de aspect. Oferă opțiuni diferite în funcție de selecția dvs., de exemplu, formatarea textului.`,
's80a42b81c52d4d8f': `Culoare Caret`,
's80b71fc6f43c5ce1': `Slabă`,
's812cbda653daaeba': `Această caracteristică nu este încă implementată`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Continuați`,
's8247d32213e35f24': `Introduceți un principal`,
's82665b2ffabc9c0a': `Site web`,
's828b1ecea8715884': `Pan (stânga)`,
's833bd0422a7ef95d': `Dimensiunea filei`,
's83420ad7b6a14db5': `Toggle Instrumente de dezvoltare`,
's83c15613b6f6f3c8': `Numai online`,
's83cd32b685ccc9b7': `Controale`,
's83f26d02dd7aa681': `Vizibil`,
's840fa49e8989c028': `Poziție/Formă`,
's844a76d1843ceb3c': `Resetare la setările implicite`,
's84e4e8ae645b82ac': `Sus dreapta (y)`,
's84e9c7f8785ca60b': `Introduceți un formular`,
's8517ae4da104b004': `Grup de coloane de tabel`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licență ca Creative Commons OER?`,
's85f9aa6d3ea0e421': `Grup de subsol de tabel`,
's864b0e6270e97246': `Marcați selecția ca un comentariu secundar`,
's8670e5ad3bf0dcf8': `Salvați ca`,
's8688d74dd3716d6e': `Comenzi rapide de la tastatură pentru comenzi`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Marginea formei`,
's87cefc710b3567fb': `Conține`,
's88676f992b2965db': `Întinderea conținutului celulei`,
's886897f2fd4edb99': `Ascunse`,
's886c5db2a5579873': `Concept`,
's888c71e8fcb916d3': `Autosave`,
's88a62d29529948fb': `Introduceți un tabel`,
's89950d86c8004d4b': `Săriți fără suprapuneri`,
's89bca7498f20e041': `Clip de fundal`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pauză înainte de`,
's8a4ff2bd9c13498c': `Înregistrare`,
's8a6585c48ea104e9': `Ascundeți celulele goale`,
's8a9eb438abac7c6a': `Etichete`,
's8b0432eecbd8b034': `Actualizare`,
's8b7580c35e2aef87': `Stânga sus (y)`,
's8bc4affa761aa8a2': `Introduceți o imagine`,
's8c7f51cb067644c7': `Lista de date`,
's8d342ecaa9e75b9b': `Relația`,
's8d797888455f4147': `Spații de pauză`,
's8d83386457e91813': `Anularea/refacerea modificărilor sau previzualizarea din perspectiva cursantului.`,
's8d8643013a7754d1': `Alinierea textului`,
's8df30fe2a50d3479': `Introduceți o oportunitate de întrerupere a liniei`,
's8e715248c3a78446': `Tăiați selecția`,
's8f29e48d6b9a1aa8': `Introduceți un rând de antet de tabel`,
's8f4be9f086eb530f': `Anulare`,
's8f533296a536965e': `Salvați ca...`,
's8fad58c831ecf017': `Container de text Ruby`,
's8ffe7abcbed8eb43': `Vertical, de la stânga la dreapta`,
's90105521fcc40453': `Conturile WebWriter Cloud vă permit să stocați documente online și să le partajați
          cu elevii dumneavoastră. Adăugați un cont aici și acesta va fi disponibil ca locație
          pentru salvarea, încărcarea, partajarea și deschiderea documentelor.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta de fonturi`,
's90f7c1cf501ea0a7': `Color dodge`,
's91093e0b087911ba': `Poziția de accentuare`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Inserare embed`,
's9219acd5bef6269e': `Sub stânga`,
's92548405912d46bf': `Derulare aliniere rapidă (y)`,
's9258280591309342': `Derulați alinierea rapidă (x)`,
's927d796559f49439': `Originea fundalului`,
's92b177e579ef7b97': `Subliniere`,
's92f846b9be2e8e8d': `Marcați selecția ca italic`,
's93566b84230af4f5': `Introduceți o imagine`,
's936aa0b239679585': `Introduceți o pauză tematică (de obicei afișată ca o linie orizontală)`,
's9370dc6afa716b57': `Frontieră`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Termen definit`,
's9485af2e7cd9418f': `Școala primară`,
's94d2eee44b292567': `Comutați opțiunile avansate`,
's94d61907ee22a8c1': `Coreeană`,
's94eb1effbbb6498b': `Revărsare`,
's951aa3a6439f1271': `Marcator de listă`,
's9565553d163fc92a': `Script`,
's957787fc6b7ea5c0': `Pan (sus)`,
's95d56e58f816d211': `olandeză`,
's95d8e41a64635c7c': `Spațiu alb`,
's95de7e1eff6c053e': `Orizontal, de sus în jos`,
's960d3a90ac199368': `Reto-română`,
's96532132a29dd542': `Introduceți audio`,
's96a045dcade75ad0': `Coloană densă`,
's9781a5bb3fcb26a3': `Selectați mai întâi o companie`,
's978522fbc9577a7e': `somaleză`,
's97881699a2b21d5b': `Decalaj între rânduri`,
's97aa76056a81bd36': `Metrici`,
's986facb3ecc9602c': `În lateral, de la dreapta la stânga`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Fișier extern`,
's98977a87d1b93941': `Resetați informațiile, stilurile și scripturile`,
's990d0e0fa2ab00b5': `galiciană`,
's99229574e5692f19': `Groenlandeză`,
's99a990f3841ad283': `Fișiere de `,
's99b38e000175cc84': `Strikethrough`,
's99f110d27e30b289': `Titlu`,
's9ab10fbf4c7a7322': `Poziția sublinierii`,
's9abadcc828884d7b': `Textarea`,
's9b7cd8860c8fc922': str`
          ${0}
          va fi suprascrisă. Sunteți sigur? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Culoarea fundalului`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Coloană de tabel`,
's9cf68f87b8e6122f': `Azerbaidjan`,
's9d167ef77aed79b6': `Strat`,
's9d2d00982edafabb': `Turcă`,
's9d430adc5be110e9': `Rând invers`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Ștergere`,
's9df571714a1efb44': `O versiune salvată automat a acestui explorabil este disponibilă. O încărcați?`,
's9e28faa598332e2b': `Introduceți video`,
's9e3dbb678150edd4': `Setați familia de fonturi`,
's9e40e59654c8ad67': `Coloană`,
's9e85800d3700e31c': `Track`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variantă de font`,
's9f1ecdb3061d9cbc': `Conservarea spațiilor`,
's9faf26107ed49fb9': `Introduceți o celulă de tabel`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Tranziția`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Pânză`,
'sa00df4e39c72d3b4': str`
          ${0} nu este acceptat 
        `,
'sa013e119fec906fb': `Rând`,
'sa01e7bf33563ef72': `Anexă de fond`,
'sa126cf8c627cec1e': `Redarea imaginii`,
'sa13f72278add7513': `Sub dreapta`,
'sa1647e3b36ec08d7': `Combinați în poziție verticală`,
'sa172190ea21f9b1c': `Accesați setările, deschideți un explorabil sau creați unul nou.`,
'sa1c6c459b9b5115c': `Absolut`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Șablon grilă`,
'sa30c12014e955946': `Rusă`,
'sa30f1981fd1cd441': `Dimensiunea fontului`,
'sa311a24c1471a974': `Document`,
'sa352d168b262aa06': `Introduceți un subsol`,
'sa37fee6a52d18063': `Ștergeți documentul`,
'sa39c7ac1d37f3bce': `Marcați selecția ca un "izolat bidirecțional`,
'sa3b4c01623211544': `Forța`,
'sa40fd43756fa8913': `Persană`,
'sa417644bef21a9aa': `Temă fără nume`,
'sa43800e28be1bdbc': `Culoare de decorare`,
'sa477cb1825dceb3b': `sudanez`,
'sa492a51a707930fa': `Introduceți un citat bloc`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Legenda de jos`,
'sa50d3c35533f1d99': `Toate domeniile`,
'sa53c5cb03a8fda50': `Fixați selecția ca fragment în paletă`,
'sa557ae6bee9148a6': `Progres`,
'sa589e1df65dde0ec': `Setați dimensiunea, umplutura și marginile elementelor selectate`,
'sa5c371b4bb75e590': `Stânga`,
'sa5c80e623459ffe4': `Introduceți un antet`,
'sa5df1bcdba46c3fb': `Figura Caption`,
'sa602e3fd3f2d98fd': `Animație`,
'sa644d580d8a11e60': `Alinierea la rubin`,
'sa645d315510dc09e': `Alegeți calea de pe disc`,
'sa65d4ad99f1d8c06': `Setați fundalul textului`,
'sa6607436f60ccc1a': `Estonă`,
'sa6f8d27bca557059': `Mutați elementele meta/link/style sus/jos în acest element`,
'sa757645ad842da97': `Păstrați pauzele`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Derulați`,
'sa778acc33947c7b8': `Termină turul`,
'sa78a67272a4a6f95': `Formula matematică`,
'sa79167651dce1e80': `Text alternativ`,
'sa7af797a46c7d09a': `Picior de tabel`,
'sa7dbe35b758c138d': `Introduceți o pânză`,
'sa7dc6b8ef3f595dc': `Introduceți o sursă`,
'sa8279f8211b3950d': `Păstrați pauzele și spațiile`,
'sa8b55cab62e439b5': `Îndepărtați coloana`,
'sa8bbe0197d31b423': `Scurtă descriere`,
'sa9ff3b762365abe6': `Originea transformării (z)`,
'saa02e3762368ff35': `Originea transformării (y)`,
'saa065776236bfa28': `Transformați originea (x)`,
'saa33768e03c45fc8': `Dimensiunea fișierului`,
'saaad98061a20ac39': `Introduceți o formulă matematică`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternați peste`,
'saaec15c97a9e4245': `Coloană inversă`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Rezoluție snap pixeli`,
'sab55faae8e165407': `Padding&lt;br&gt; ca decalaj`,
'sab5e7d2a069a2951': `Certificat profesional.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Alinierea la dreapta`,
'sac895c732f350ac5': `Întuneric`,
'saced41ddda8b2354': `Baza flexibilă`,
'sad190f86451081c0': `Nepaleză`,
'sad6be321164d08c8': `Matematică compactă`,
'sadd352cc7f6f2307': `În afară de`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `suedeză`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tătar`,
'saf312eaeec77a802': `Introduceți o listă de descrieri (glosar, listă de termeni)`,
'saf3da7c95cb17260': `Marcați selecția ca un superscript`,
'saf440a0a592f2835': `Actualizare la`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Comută previzualizarea pentru documentul activ`,
'sb0a7e3adf4a125ee': `Sus dreapta`,
'sb0a974028c99ca6d': `Permiteți adaptări?`,
'sb0d4f0f7993cf085': `Setați dimensiunea fontului`,
'sb0f3327210fe18fc': `Coloane`,
'sb0f93c1c60c0249a': `Rubin de bază`,
'sb1494c08c8c720d1': `Setați culoarea textului`,
'sb19611adbc88f711': `Avansate: Afișați comenzile de editare a sursei, de exemplu, pentru a afișa HTML-ul documentului sau pentru a adăuga stiluri și scripturi personalizate.`,
'sb206d700d26b14ff': `Subliniere`,
'sb233557012dcb328': `Coborâți`,
'sb26035b596566abf': `Fără nume`,
'sb2cda80610c8d6ea': `Spațiu toate`,
'sb2dc787b0983ebc6': `lituaniană`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centrul`,
'sb3ba3276ae93627c': `Introduceți un bloc de text preformatat`,
'sb430f5b4824de0d3': `Alegeți un aspect`,
'sb43db07b24da018a': `Amharic`,
'sb45f9fb4dba6e71a': `Dezactivat`,
'sb4e003a459464d85': `kurdă`,
'sb4f0310e6787d098': `uzbecă`,
'sb4f1dffbb6be6302': `Clar`,
'sb51270e19988f9bd': `Regiunea`,
'sb59d621e3c93cc27': `Granițe de celule partajate`,
'sb5e9e1776242b028': `Interacțiuni`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doctorat`,
'sb6103872073d369e': `Introduceți detalii`,
'sb616811735bfbafd': `Celulă de tabel`,
'sb628960829e223bb': `Săriți peste toate suprapunerile`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Aplicare și import`,
'sb66e2181a7b5738a': `Prin activarea telemetriei, permiteți colectarea și păstrarea datelor în conformitate cu`,
'sb67e0e7c0869f982': `Diferența`,
'sb68e83cda6c85af8': `Tabelul de antet`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Grosimea decorului`,
'sb70c17f7899f9b01': `Latină`,
'sb71941f552f3504d': `Setați o valoare specială`,
'sb740eab4afd5a710': `Flux automat al rețelei`,
'sb741b6e0ca589122': `Revenire strat`,
'sb7c77d0415de05cf': `Efectuați teste`,
'sb7fb7568f6883ab8': `Partajați documentul activ`,
'sb85774dc5d18ff0f': `Confirmați`,
'sb85b1e36579852a6': `E-mail sau parolă invalidă`,
'sb884fa76bfc55429': `arabă`,
'sb8a3d4df7d1c5e6b': `Echilibru`,
'sb8f610a0e8df91fc': `Luminozitate`,
'sb8f855b49234b81b': `Aplicați`,
'sb905da066c10182c': `Plus mai întunecate`,
'sb940ade1bd81be7e': `Sub stânga`,
'sb9e9a7dd45966756': `Marcați selecția ca fiind bold`,
'sba509fd8ed61d1d5': `Fișier nesalvat`,
'sba64d8954d027206': `Opacitate`,
'sba88d90cd6c751b3': `Regula coloanei`,
'sbaf0a7c417e388af': `Sănătate`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtru de fundal`,
'sbb85a407d730e13d': `Introduceți o căutare`,
'sbb86c6c96f598bb8': `Mixte`,
'sbba0156f795d8c07': `Editare selecție`,
'sbba865d4b437944f': `Atribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Dezinstalare`,
'sbc5f2a81604baf9b': `Rubrica 6`,
'sbc5f2b81604bb14e': `Rubrica 5`,
'sbc5f2c81604bb301': `Rubrica 4`,
'sbc5f2d81604bb4b4': `Rubrica 3`,
'sbc5f2e81604bb667': `Rubrica 2`,
'sbc6953a36ced943f': `politica de confidențialitate`,
'sbd181cd54b8402a4': `Editați selecția`,
'sbd35ee879d9cf770': `Text rubin`,
'sbd40f40cbadd38d5': `Eliminați acest pachet de widget-uri`,
'sbd72dc858de95ce8': `birmaneză`,
'sbe3c60c65f129daa': `Științe umaniste`,
'sbe4a7c8f231739b3': `sau lipiți/lipiți/alegeți fișierul`,
'sbe90de083557ef3e': `swahili`,
'sbefb6064cba01844': `Introduceți o întrerupere de linie`,
'sbf00e1ee999ea94e': `Introduceți un script`,
'sbf519920c2017d67': `Suspendare`,
'sbfa01f189a68d3e9': `Creștere flexibilă`,
'sbff54e740c4086eb': `Afișați pachetele necunoscute`,
'sbfff51feacf30196': `Sanscrită`,
'sc0ceaa9843510f67': `Turkmenă`,
'sc1611c0558728a2a': `Poziția`,
'sc1a155cc25899250': `Grup de rânduri de tabel`,
'sc1aa1f6051b7102a': `română`,
'sc1edebeaef92b7bd': `Dispunere fixă a tabelului`,
'sc1fff4f356dfb2fb': `Transformare`,
'sc24bda3c061fddf8': `Zonă pe care se poate face clic`,
'sc252a4e091763606': `Introduceți un subsol de tabel`,
'sc2536e077514accc': `Derularea`,
'sc275dd00036d16cb': `Citate caracter`,
'sc28864200d2a3799': `Copiați codul QR ca imagine`,
'sc2a24a9dd41a9503': `Linie de decorare`,
'sc2b734cca2fa643b': `Pan (jos)`,
'sc2e2a0dbf03723b7': `Avansat: Afișați pachete din surse necunoscute în managerul de pachete (Avertisment: Poate fi nesigur)`,
'sc3998b77d72c2932': `Introduceți un site web (ca un cadru în linie)`,
'sc3ac225273c8316b': `Generalități`,
'sc3cfee84dbbf36ae': `Fișier local`,
'sc3f09a9b6fa4fbed': `Interior`,
'sc43767deea72e9f3': `Lista de descriere`,
'sc462bbdd36bcba6b': `Caseta de referință`,
'sc4ee3e4ee994dafd': `Ucraineană`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Originea perspectivei (y)`,
'sc52e8b794c0913d6': `Originea perspectivei (x)`,
'sc53de149fcaad713': `Inter-personaj`,
'sc546f489f9c0cced': `Schimbă modul de testare pentru documentul activ`,
'sc5bcf50d1b578d9f': `Setări caracteristici font`,
'sc5cb39478b9b7625': `Marcați selecția ca subscript`,
'sc6415b50ff928294': `Element de listă`,
'sc650ff15b20fe9d3': `Rotire (z)`,
'sc6578b15b2154365': `Rotire (x)`,
'sc65aff15b2183e58': `Rotire (y)`,
'sc6da0f4a7e4d710e': `Suprascriere limbă font`,
'sc74e3567875ce255': `Atât eticheta widget-ului dvs., cât și numele pachetului NPM`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Mutare (x)`,
'sc8af536e2084ade0': `Paletă`,
'sc8b022f92b992bc2': `Mișcare (y)`,
'sc8b39af92b9c2d81': `Mișcare (z)`,
'sc8d2c7f6c33a2b32': `Setarea stilului de text (aliniere, indentare, spațiere etc.) al elementelor
          selectate`,
'sc8fa0e3de389ef1c': `Ajustarea dimensiunii fontului`,
'sc9474bf7a0668d73': `Rezumat`,
'sc94e314312a8900c': `Cehă`,
'sc980855a000b76ea': `Fund`,
'sc98b103772de63f4': `finlandeză`,
'sca7cfe2bef51b2a5': `Rădăcină`,
'sca7fed2bef53cb99': `Rol`,
'scabe6ecee5e01fd2': `Malteză`,
'scace301a88231cce': `Embed`,
'scbc55f622ec078c1': `Vezi caseta`,
'scbe537fc38ff4c13': `Grilă cu coloane automate`,
'scc1db59d292cbc4c': `Secțiunea`,
'scc56b218a2689c42': `armeană`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Cutie de căptușeală`,
'scd9cedeb5ece3adb': `Hyphenate`,
'scdf536b65be39ec5': ` Creare/import`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografic`,
'sceecdd0bb404bc17': `Introduceți un grup de opțiuni`,
'scf00d48fd5953a03': `Greacă`,
'scf932840a69dbb7c': `portugheză`,
'scf932a8577057752': `Footer`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Jos dreapta`,
'sd01178c54f648118': `Coloane de echilibru`,
'sd03bff50f87f82d4': `Caracter cu cratimă`,
'sd05a155fe09c2866': `Online atunci când utilizați`,
'sd0864ea6cb6ef22e': `Comunitate`,
'sd10fdbe6caf9a998': `Întrerupere de linie`,
'sd121d3b959b7888d': `Optimizarea vitezei`,
'sd1a78e667a1a139f': `Marcați selecția ca o inserție`,
'sd1cffad290ea5b3b': `Păstrați toate`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Umpleți`,
'sd29dc07235eea0f5': `Cotație`,
'sd2addf69477cd4b4': `Pachet de import`,
'sd2ed26defc646d47': `Filtru pentru fundal`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fix`,
'sd3a288c1094b8a63': `Lățimea regulii coloanei`,
'sd3c65ef5c380c046': `Inserție`,
'sd3dcb76f7b28adb8': `Letonă`,
'sd3eca1e0f4209f6e': `Tăiați toate`,
'sd3f402df8619ddcd': `Aceste informații despre dvs. sunt adăugate automat la documentele noi. Puteți
          modifica acest lucru pentru fiecare document în editorul de metadate.`,
'sd4368b12645d3c0f': `Introduceți un portal`,
'sd452cebf4a0313d1': `Afișați comenzile de editare a sursei`,
'sd48cc52117f4d68b': `Italiană`,
'sd52660ee947ca58b': `Introduceți o coloană de tabel`,
'sd588d17a1b25c220': `Depășirea textului`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Ed. superioară.`,
'sd5cf95145e4d89ca': `Decuplați acest fragment`,
'sd5fd9d11a92f5b1d': `În stânga jos (y)`,
'sd60c9bbc51375635': `Introduceți un buton`,
'sd66c4767fa3dde28': `Accent de culoare`,
'sd679c8b1bf8cc8a5': `Capsule mici`,
'sd7086c4425c53c80': `Familie de fonturi`,
'sd837f42ac7cbfb58': `Formă (exterior)`,
'sd88076d2994ee0fb': `Excludere`,
'sd89a2e529b31ef43': `Revenire`,
'sd8a345e95668b73b': `Vertical, de la dreapta la stânga`,
'sd8ce9e57270b030d': `Font stretch`,
'sd8ecf227c7c49331': `Matematică`,
'sd8f923198e0c5c6a': `Sfârșit`,
'sd9c21e5f60d6bdd8': `daneză`,
'sd9ff8e2612e63d50': `Dimensionarea casetei de frontieră`,
'sda2d76b976502a8d': `Deschide...`,
'sda344aacb837387e': `Poziția în container`,
'sda5b6fa8b771f996': `Flotor stânga`,
'sda9254d1f1228e1a': `maghiară`,
'sdb1595f5c742dfbb': `Introducere`,
'sdb711380a28fec75': `Introduceți o listă (ordonată)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `În dreapta jos (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `georgiană`,
'sdd1ff479d04ac140': `Public`,
'sdd2fc8919a9c3111': `Modul de amestecare a fundalului`,
'sdd35b688281b6dea': `Japoneză`,
'sddc49047f66a64ab': `Nu a fost furnizată nicio descriere`,
'sdef34fe08bb28b09': `Chineză (simplificată)`,
'sdf62e305e1594805': `Marcați selecția cu o adnotare ruby`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Aliniere`,
'se036b53f145441cd': `Conținut mixt`,
'se06f459fccdc3ce9': `Alinierea ultimei linii de text`,
'se0a782a8be8e018b': `Norvegiană`,
'se0cda6b80a1bb50f': `Slovacă`,
'se0f67eae944f8f94': `Mută`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Articol`,
'se1f5bb0386c88f96': `Setează culoarea textului selectat`,
'se219da7b1e955c65': `Formatare clară`,
'se25e4f2cb77b8be8': `Limbaj pentru interfața WebWriter și documente noi`,
'se2796c5824ec8916': `Vizibilitatea conținutului`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Oriunde`,
'se39c065efa467782': `bască`,
'se3b4c857f91f80d7': `Comenzi rapide de la tastatură`,
'se47baf2fd16b9d2b': `Șablon`,
'se48bd9e6c2a3109d': `Conturi`,
'se58467472725ad0c': `Rezoluția imaginii`,
'se58f06c2b0583ff7': `Alegeți coordonatele`,
'se5dc1e97fb743ade': `Spațiere`,
'se619a501d1bfe6a5': `Înfășurare`,
'se62385ac082368d2': `Marcați selecția ca sursă de citare`,
'se6297163cac9d276': `Editează sursa`,
'se633223a0b88625e': `Plasarea celulelor`,
'se638417c560cfe5c': `Spargere în interior`,
'se64f418b4e733b6c': `Introduceți o ieșire`,
'se79c0a3ac70d8fb3': `Raportul de absorbție (x)`,
'se79fae3ac710dc36': `Asp. raport (y)`,
'se7fad370d8fb4cec': `Optimizați lizibilitatea`,
'se8a94b4effa2033e': `Alfabetic`,
'se95d4e55ea186d9a': `Culoarea barei de derulare`,
'se96d43a515b8451c': `Slovenă`,
'se96fd76ba1b2975a': `Centrală`,
'se9ac05f36b004eb0': `Ascundeți turul introductiv. Dezactivați astfel încât turul să fie afișat din nou.`,
'se9b1fec72ffd8f48': `Local`,
'sea24bdcaa2bd2dec': `Snap obligatoriu`,
'sea52df2b70a5c10d': `Rubin`,
'sea6e7291e27ec53f': `Comută editorul de metadate`,
'sea896ed51ad33287': `Nu sunt disponibile stiluri specifice`,
'seaaaeb09e3b4e78b': `Comenzi de editare`,
'seabae79729c4b2ad': `Toggle e-mail`,
'seaecc8267bad6234': `Școala gimnazială`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Evitați coloana`,
'seb4e52ef5ec7a7dc': `Culori/Efecte`,
'seb8982ae8c3cdcc5': `Indoneziană`,
'sebbced89e0db2894': `Prima linie de bază`,
'sec02109a0dd2a6c8': `Accent pe culoare`,
'sec2557a35b702525': `Variabilă`,
'sec2da4aa7a02b925': `islandeză`,
'sec30fbb20f102670': `Introduceți un rezumat`,
'sec8b0b6c729816b6': `Grup șef`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `Directorul în care este localizat package.json`,
'sed318ec045c5144f': `Peste`,
'sed713f1b916fb469': `Distanța dintre margini (x)`,
'sed74a31b9172942c': `Distanța dintre margini (y)`,
'sed86bd0deb2e5372': `Transformarea textului`,
'see2fcaedf9743ec6': `Locație`,
'seec6798afe90ffc8': `Imprimare`,
'sef00c258bc1ecf1e': `Acest explorabil are modificări nesalvate.`,
'sef23dd271edd4a8b': `Jos la stânga`,
'sef24caccbd4645ef': `Contracție flexibilă`,
'sef49aec68fd1dc66': `Nume și prenume`,
'sef73fe18e351eb35': `Cuvinte-cheie`,
'sef75f458d77491af': `Grup de opțiuni`,
'sefcf950b3cc4fc3b': `Limba`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Cuprins`,
'sf0cab2483f66aa2e': `Personalizat`,
'sf0e261e04eda82ff': `Aspect`,
'sf1045382c1fd9a85': `Culori exacte de imprimare`,
'sf14c35392ec7bf10': `Această caracteristică nu este disponibilă în Firefox. Este disponibilă în Chrome sau Edge.`,
'sf14f9d5f9f6ca342': `Plus brichetă`,
'sf1868dc19e3917bb': `spaniolă`,
'sf190149f9d8bbb2a': `Mod de scriere`,
'sf1e79171c4856543': `Sunteți sigur? Această acțiune nu poate fi anulată, toate setările dvs. vor fi
          șterse și resetate.`,
'sf21c1f60c7515f44': `Marcați selecția ca probă de ieșire`,
'sf21fb4f4b9e8911f': `Lățime`,
'sf22a3737146ec910': `WebWriter poate încorpora SVG direct în document.`,
'sf2514d5dc78b1654': `Inserare widget`,
'sf28903d4ca0ddcfc': `Eliminați acest cont`,
'sf2ab37af0abc55ef': `Ascundeți turul introductiv`,
'sf2bdb0b4d7b9c039': `Bengaleză`,
'sf2cbb5e519264e67': `Redimensionați atât pe orizontală, cât și pe verticală`,
'sf2d5cbc2fe0ad65a': `Lipicios`,
'sf2d96d0eb32cb81f': `Compoziția animației`,
'sf2de3dbe2108637a': `Redarea formei`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `În linie`,
'sf39736a666dbb038': `Introduceți o piesă`,
'sf3c4da68b08a2590': `Malgașă`,
'sf471ec2496f904cc': `Respingeți modificările`,
'sf4849bc200e279ed': `Legenda tabelului`,
'sf486ca1fdbe08645': `Introduceți o figură`,
'sf4b537d4cbd8f5fd': `Text sus`,
'sf4e0e02a5277ef23': `Introduceți o zonă de text`,
'sf4f067d41efd4b83': `Scară (y)`,
'sf4f3cbd41f002b46': `Scară (x)`,
'sf4fa67d41f05a008': `Scară (z)`,
'sf5197db2d5f2926a': `Rotiți`,
'sf52d840949a980d1': str`
          ${0}
          vor fi șterse definitiv. Sunteți sigur? 
        `,
'sf55d634dcc743595': `Servicii`,
'sf59c9081d106dd9c': `Marcați selecția ca o variabilă`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Ștergeți un document`,
'sf65df67a03bebe4b': `Necesar pentru acest widget`,
'sf6673729c03ae999': `Resetați WebWriter`,
'sf67571992e7dc88e': `Termen complet`,
'sf6b4934598f7ed10': `Permiteți selectarea`,
'sf6e1665c7022a1f8': `Parolă`,
'sf79e0d78b56444f1': `Sfârșit în linie`,
'sf7a5f7a7c80c3082': `Ambele`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `Marcați selecția ca cod`,
'sf8e82313fa411494': `Marcați selecția ca o legătură`,
'sf955eff73fb6b573': `sârbă`,
'sf9929e2d356260c5': `Înmulțiți`,
'sf993bb199fefbe04': `Toate`,
'sf9ecf969dd4b8164': `Ambele margini`,
'sf9f2c719a04066ec': `Aplicație`,
'sfa49a5bb1a5d353e': `Acces privat`,
'sfa59c7777e2a0eeb': `Introduceți o listă de date`,
'sfaa0a67db5c11f72': `Indentare prima linie de text`,
'sfb231a52211b133f': `Fără text wrap`,
'sfb68cae41d749423': `Inițial`,
'sfb9b6edb0ed378c9': `Sursa de citare`,
'sfbbab09dbe553571': `Introduceți un desen vectorial (SVG)`,
'sfc00292e778b67e2': `Contor`,
'sfc63e31ac7c956ed': `Selectați`,
'sfc815c9078bba30a': `Descărcați codul QR ca imagine`,
'sfcdd8e672c75b713': `Adresă`,
'sfcebd18506f1e535': `Flux`,
'sfd0cde85070d2eb2': `Flexibilitate`,
'sfd77270c3f54f664': `Ieșire`,
'sfdb1e4d90981a535': `Distribuiți acest document`,
'sfdeef3dccf409f81': `Acest cuvânt cheie este necesar pentru widget-uri`,
'sfe6e758ad2603c1d': `Masterat`,
'sfee1c12daf838935': `Arderea culorii`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Introduceți un dialog`,
'sffa395f64ec6ac36': `bulgară`,
'sffdadf0a576fd802': `Înălțime`,
'spaceKey': `Spațiu`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Sus`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  